import axios, { AxiosInstance } from 'axios';

export abstract class HttpClient {
	private static instance: AxiosInstance;
	private static adminInstance: AxiosInstance;

	private static getHeaders() {
		const headers: Record<string, string> = {
			'app-type': 'full',
		};
		
		const organizationId = localStorage.getItem('BYOD-organizationId');
		console.log('organizationId', organizationId);
		if (organizationId) {
			headers['X-Tenant'] = organizationId;
		}
		
		return headers;
	}

	public static getInstance(): AxiosInstance {
		if (!HttpClient.instance) {
			HttpClient.instance = axios.create({
				baseURL: process.env.REACT_APP_API_URL,
				timeout: 120000,
				headers: HttpClient.getHeaders(),
			});
		}
		return HttpClient.instance;
	}


	private static getAdminHeaders() {
		const headers: Record<string, string> = {
			'app-type': 'secondary',
		};
		
		const organizationId = localStorage.getItem('BYOD-organizationId');
		if (organizationId) {
			headers['X-Tenant'] = organizationId;
		}
		
		return headers;
	}

	public static getAdmininstance(): AxiosInstance {
		if (!HttpClient.adminInstance) {
			HttpClient.adminInstance = axios.create({
				baseURL: process.env.REACT_APP_ADMIN_API_URL,
				timeout: 120000,
				headers: HttpClient.getAdminHeaders(),
			});
		}
		return HttpClient.adminInstance;
	}

}
